import { Injectable, Input } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';
import { MessageService } from "primeng/api";

@Injectable()
export class CatReconCommentViewerService {
  @Input('selectedTabIndex') selectedTabIndex: any = [];

  constructor(
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    private messageService: MessageService,
    public constantService: ConstantService) {
  }

  getCatReconComments(payload:any) {
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Recon_All_Comments), payload);
  }

  addCatReconComment(payload:any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Added User Comment", null, {
        'Text1': this.userService.userFirstName + ' added Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
      });
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Add_Recon_Comment), payload);
  }

  deleteCatReconComment(payload:any) {
    /* Catch User Action Log */
      this.userService.logUserActivity("Deleted User Comment", null, {
        'Text1': this.userService.userFirstName + ' deleted Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
      });
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Delete_Recon_Comment), payload);
  }

  exportCSV(gridColumns:any, filterParams:any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    const filename = 'RSMS_Recon_Comment_' + this.userService.getyyyyMMddDateFormate(new Date());

    let headerColumns = gridColumns.filter((colObj:any) => colObj.ui_columnname !== "Comment ID");

    this.getCatReconComments(filterParams)
      .subscribe({
        next: (Element: any) => {
          let dataset: any = Element;
          let exportData: any[] = [];
          let data = dataset.Data;
          if ((data['clientCAT'] && data['clientCAT'].length > 0) || (data['clientData'] && data['clientData'].length > 0) || 
            (data['catData'] && data['catData'].length > 0) || (data['catSubmission'] && data['catSubmission'].length > 0) || 
            (data['catMonthlySummary'] && data['catMonthlySummary'].length > 0) || (data["allBrowsedComments"] && data["allBrowsedComments"].length > 0)) 
          {
              Object.keys(data).forEach(col => {
                if(data[col].length > 0) {
                  data[col].forEach((column:any) => {
                    delete column.commentID;
                    exportData.push(column);
                  })
                }
              });
            const options:any = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalSeparator: '.',
              showLabels: true,
              showTitle: true,
              title: filename,
              useTextFile: false,
              useBom: true,
              useKeysAsHeaders: true,
              filename: filename
            };
            const csv = generateCsv(options)(this.constantService.getExportData(exportData, headerColumns));
            const blob = asBlob(options)(csv);
            saveAs(blob, filename);
            this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'File Download Successfully | ' + (exportData.length > 0 ? exportData.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams)
            });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'No data found',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams)
            });
          }
        },
        error: (e) => {
            console.error(e);
        }
      });  
  }

}